import { useGetNodes } from "../../../../pages/nodes/hooks/useGetNodes";
import { useCustomerIdGuard } from "../../../hooks/useCustomerIdGuard";

export const useGetNodesWithoutDeviceByCustomer = (locationId?: string) => {
  const selectedCustomerId = useCustomerIdGuard();

  const { data, loading } = useGetNodes(
    locationId
      ? { locationId, includeDevices: false }
      : { customerId: selectedCustomerId, includeDevices: false }
  );

  return {
    data,
    loading,
  };
};
